const triggerCustomEvent = (eventName, payload = {}) => {
    const event = new CustomEvent(eventName, {
        detail: payload,
    });
    window.dispatchEvent(event);
};
const addCustomEventListener = (eventName, eventFunction) => {
    window.addEventListener(eventName, eventFunction);
};
const removeCustomEventListener = (eventName, eventFunction) => {
    window.removeEventListener(eventName, eventFunction);
};

export { addCustomEventListener, removeCustomEventListener, triggerCustomEvent };
